<script>
  import Navigation from "../components/UI/Navigation.svelte";
  import PagesTemplate from "./PagesTemplate.svelte";
  import ImageLoader from "svelte-lazy-image-loader";
  import { scrollto } from "svelte-scrollto";
  import Skill from "../components/content/Skill.svelte";
  import { skills } from "../constants/content";

  let profile;
</script>

<style>
  .content {
    padding: 4rem 2rem;
    max-width: 64rem;
    margin: 0 auto;
  }
  @media screen and (min-width: 900px) {
    .content {
      padding: 4rem;
    }
  }
  article {
    margin-bottom: 3rem;
  }
  .profile-pic {
    border-radius: 100%;
    height: 15rem;
    width: 15rem;
    border: 5px solid var(--color-theme-2);
    overflow: hidden;
    margin: 0 auto 3rem;
    /* background: url("/images/guy.jpg") center/cover no-repeat; */
  }
  .competencies {
    height: 25rem;
    width: 25rem;
    margin: 0 auto 3rem;
  }
  .subnav {
    color: var(--color-theme-4);
  }
  .skill-category {
    margin-bottom: 3rem;
  }
  .school {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 2rem;
  }
  .school-logo {
    width: 64px;
  }
  .school-title {
    margin-bottom: 0;
    text-align: center;
  }
</style>

<PagesTemplate title="About">
  <div class="subnav" slot="subnav">
    <a href="#profile" use:scrollto={'#profile'}>Profile</a>
    /
    <a href="#competencies" use:scrollto={'#competencies'}>Competencies</a>
    /
    <a href="#skills" use:scrollto={'#skills'}>Skills</a>
    /
    <a href="#education" use:scrollto={'#education'}>Education</a>
  </div>
  <div class="content">
    <div class="profile-pic">
      <ImageLoader url="/images/guy.jpg" alt="Guy" />
    </div>
    <article bind:this={profile} id="profile">
      <h3>Profile</h3>
      <h4>I am a User Experience Designer who codes.</h4>
      <p>
        From the earliest days of my career when I taught myself to program
        Microsoft Active Server Pages and to work with SQL Databases, I have
        always to some degree incorporated code into my design work. Because I
        design web applications, it only makes sense to me to design in the
        browser. Given the choice between wireframes or high-fidelity mockups
        and an HTML version of a design, I typically choose the latter. For me
        this approach has become more expedient, especially when using an
        established design system and language. In recent years, I have seen a
        trend away from low-fidelity wireframes and mockups in favor of jumping
        straight to high-fidelity versions of a design. I cut my teeth on
        low-fidelity and still use wireframes extensively, however more often
        than not my deliverable is HTML.
      </p>
      <p>
        Also, in recent years a number of frameworks and libraries have made for
        a much easier transition into coding for anyone willing to invest the
        time into learning HTML, CSS, and JavaScript. Over the years HTML and
        CSS have been relatively easy to stay current with, however in the
        absence of working with JavaScript day in and day out, it wasn't as easy
        to maintain proficiency with it. Several years ago, I changed that and
        dedicated myself to learning it so that I could take full advantage of
        JavaScript frameworks and libraries that are in wide use today, such as
        React, VueJS, and AngularJS, and Svelte (my preferred, which is actually
        a compiler and not a full-blown framework).
      </p>
      <h4>Prototype Engineer?</h4>
      <p>
        The above frameworks and libraries combined with established design
        langages that many organizations have in place have allowed me to move
        into my current role as a Prototype Engineer (using
        <a
          href="https://www.uxmatters.com/mt/archives/2007/11/the-five-competencies-of-user-experience-design.php"
          target="_blank">
          The Five Competencies of User Experience Design
        </a>
        for reference). In this capacity and at the time of this writing, I am
        working with Sabre's Research and Labs team to flesh out ideas for
        future revenue generating opportunities in the form of new and
        innovative products. My outcome is either a prototypye or a demo to
        elicit feedback on the product's potential. The process to this result
        entails working either solo or with another designer to establish the
        product's Information Architecture, work flows, Interaction Design, and
        ultimately the programming of the User Interface.
      </p>
      <!-- <p>
        My career started out in the healthcare industry as a Business Analyst
        in the early days of the internet. It was during this time that I became
        interested in , where I Business Analysis circa Web 1.0 and quickly
        moved into programming of Microsoft ASP/SQL and Cold Fusion web
        applications. From there I moved into Information Architecture and the
        Design side of things, finally landing in User Experience Design. Along
        the way I managed to maintain programming skills, which has allowed me
        to move back into more development-focused projects consisting of fully
        functional demos and prototypes.
      </p> -->
    </article>
    <article id="competencies">
      <h3>Competencies</h3>
      <div class="competencies">
        <ImageLoader url="/images/Competencies@2x.png" />
      </div>
      <p>
        The very fact that I'm using a data visualization might actually be
        enough to communicate where I fall on the User Experience competency
        spectrum. Again using
        <a
          href="https://www.uxmatters.com/mt/archives/2007/11/the-five-competencies-of-user-experience-design.php"
          target="_blank">
          The Five Competencies of User Experience Design
        </a>
        for reference, I am strongest in User Interface and Interation Design,
        as well as Prototyping and any coding involved in that. I transitioned
        into Design from programming originally, so naturally my interest and
        expertise has been on the more analytical and technical side of the UX
        discipline. Information Architecture was a big part of what I did
        earlier in my career, and remains an inherent part of my design work.
        Usability and Visual Design are relatively lower competencies - but
        competencies nevertheless - and still very much part and parcel to what
        I do.
      </p>
    </article>
    <article id="skills">
      <h3>Skills</h3>
      {#each skills as item}
        <div class="skill-category">
          <h4 class="text-center">{item.category}</h4>
          {#each item.items as item}
            <Skill {item} />
          {/each}
        </div>
      {/each}
    </article>
    <article id="education">
      <h3>Education</h3>
      <div class="row">
        <div class="col-12 col-6-lg school">
          <div class="school-logo">
            <ImageLoader
              url="/images/TCU_Horned_Frogs_logo.svg"
              alt="TCU logo" />
          </div>
          <p class="school-title">
            <strong>Texas Christian University</strong>
            <br />
            Fort Worth, Texas
          </p>
          <p>MBA, 1994</p>
        </div>
        <div class="col-12 col-6-lg school">
          <div class="school-logo">
            <ImageLoader
              url="/images/Texas_Longhorns_logo.svg"
              alt="Longhorns logo" />
          </div>
          <p class="school-title">
            <strong>The University of Texas</strong>
            <br />
            Austin, Texas
          </p>
          <p>BBA, 1989</p>
        </div>
      </div>
    </article>
  </div>
</PagesTemplate>
